// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cmd-backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--cui-z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: rgba(15, 23, 42, 0.5);
  animation: cmd-fade 0.15s ease both;
}

.cmd-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100vh - 48px);
  border-radius: var(--cui-radius-lg);
  background: var(--cui-bg);
  box-shadow: var(--cui-shadow-lg);
  outline: none;
  animation: cmd-pop 0.18s ease both;
}

.cmd-sm { max-width: 420px; }
.cmd-md { max-width: 580px; }
.cmd-lg { max-width: 820px; }
.cmd-xl { max-width: 1120px; }
.cmd-full {
  max-width: none;
  height: calc(100vh - 48px);
}

/* ---------- header (stays put) ---------- */
.cmd-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
  padding: 18px 20px 14px;
  border-bottom: 1px solid var(--cui-border-soft);
}

.cmd-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 10px;
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
}

.cmd-titles {
  flex: 1 1 auto;
  min-width: 0;
}

.cmd-title {
  margin: 0;
  color: var(--cui-text);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.cmd-subtitle {
  margin: 3px 0 0;
  color: var(--cui-text-muted);
  font-size: var(--cui-font-size);
  line-height: 1.45;
}

.cmd-close {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin: -4px -6px 0 0;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--cui-text-muted);
  cursor: pointer;
  transition: background var(--cui-transition), color var(--cui-transition);
}

.cmd-close:hover {
  background: var(--cui-bg-hover);
  color: var(--cui-text);
}

.cmd-close:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

/* ---------- body (scrolls) ---------- */
.cmd-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 18px 20px;
  overflow-y: auto;
  color: var(--cui-text);
  font-size: var(--cui-font-size);
}

/* ---------- footer (stays put) ---------- */
.cmd-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
  padding: 14px 20px;
  border-top: 1px solid var(--cui-border-soft);
  background: var(--cui-bg-subtle);
  border-radius: 0 0 var(--cui-radius-lg) var(--cui-radius-lg);
}

/* ---------- phones: full-width bottom sheet, stacked buttons ---------- */
@media (max-width: 576px) {
  .cmd-backdrop {
    align-items: flex-end;
    padding: 0;
  }

  .cmd-dialog,
  .cmd-full {
    max-width: none;
    max-height: 92vh;
    height: auto;
    border-radius: var(--cui-radius-lg) var(--cui-radius-lg) 0 0;
    animation-name: cmd-slide;
  }

  .cmd-header,
  .cmd-body,
  .cmd-footer {
    padding-left: 16px;
    padding-right: 16px;
  }

  .cmd-footer {
    flex-direction: column-reverse;
    border-radius: 0;
  }

  .cmd-footer > * {
    width: 100%;
  }
}

@keyframes cmd-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes cmd-pop {
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to { opacity: 1; transform: none; }
}

@keyframes cmd-slide {
  from { transform: translateY(100%); }
  to { transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .cmd-backdrop,
  .cmd-dialog {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomModal/CustomModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,kCAAkC;AACpC;;AAEA,UAAU,gBAAgB,EAAE;AAC5B,UAAU,gBAAgB,EAAE;AAC5B,UAAU,gBAAgB,EAAE;AAC5B,UAAU,iBAAiB,EAAE;AAC7B;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA,2EAA2E;AAC3E;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,4DAA4D;IAC5D,yBAAyB;EAC3B;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,eAAe,EAAE;AACxB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".cmd-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: var(--cui-z-modal);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  background: rgba(15, 23, 42, 0.5);\n  animation: cmd-fade 0.15s ease both;\n}\n\n.cmd-dialog {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-height: calc(100vh - 48px);\n  border-radius: var(--cui-radius-lg);\n  background: var(--cui-bg);\n  box-shadow: var(--cui-shadow-lg);\n  outline: none;\n  animation: cmd-pop 0.18s ease both;\n}\n\n.cmd-sm { max-width: 420px; }\n.cmd-md { max-width: 580px; }\n.cmd-lg { max-width: 820px; }\n.cmd-xl { max-width: 1120px; }\n.cmd-full {\n  max-width: none;\n  height: calc(100vh - 48px);\n}\n\n/* ---------- header (stays put) ---------- */\n.cmd-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-shrink: 0;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid var(--cui-border-soft);\n}\n\n.cmd-icon {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n}\n\n.cmd-titles {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.cmd-title {\n  margin: 0;\n  color: var(--cui-text);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.cmd-subtitle {\n  margin: 3px 0 0;\n  color: var(--cui-text-muted);\n  font-size: var(--cui-font-size);\n  line-height: 1.45;\n}\n\n.cmd-close {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  margin: -4px -6px 0 0;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--cui-text-muted);\n  cursor: pointer;\n  transition: background var(--cui-transition), color var(--cui-transition);\n}\n\n.cmd-close:hover {\n  background: var(--cui-bg-hover);\n  color: var(--cui-text);\n}\n\n.cmd-close:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n/* ---------- body (scrolls) ---------- */\n.cmd-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 18px 20px;\n  overflow-y: auto;\n  color: var(--cui-text);\n  font-size: var(--cui-font-size);\n}\n\n/* ---------- footer (stays put) ---------- */\n.cmd-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-shrink: 0;\n  padding: 14px 20px;\n  border-top: 1px solid var(--cui-border-soft);\n  background: var(--cui-bg-subtle);\n  border-radius: 0 0 var(--cui-radius-lg) var(--cui-radius-lg);\n}\n\n/* ---------- phones: full-width bottom sheet, stacked buttons ---------- */\n@media (max-width: 576px) {\n  .cmd-backdrop {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .cmd-dialog,\n  .cmd-full {\n    max-width: none;\n    max-height: 92vh;\n    height: auto;\n    border-radius: var(--cui-radius-lg) var(--cui-radius-lg) 0 0;\n    animation-name: cmd-slide;\n  }\n\n  .cmd-header,\n  .cmd-body,\n  .cmd-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .cmd-footer {\n    flex-direction: column-reverse;\n    border-radius: 0;\n  }\n\n  .cmd-footer > * {\n    width: 100%;\n  }\n}\n\n@keyframes cmd-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes cmd-pop {\n  from { opacity: 0; transform: translateY(8px) scale(0.98); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes cmd-slide {\n  from { transform: translateY(100%); }\n  to { transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cmd-backdrop,\n  .cmd-dialog {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
